module.exports = __webpack_public_path__ + "res/Roboto-Condensed-webfont.svg?e38070a57a3a1e6ad69a9df6ec9ebfe8";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Condensed-webfont.svg
// module id = 40
// module chunks = 0